export default "__VITE_ASSET__CXuS8x3O__"